export const color3 = '#e6e6e6';
export const color4 = '#df3014';
export const color5 = '#35A47C';
export const color6 = '#fac917';
export const color7 = '#f2f5f8';
export const color8 = '#cbdaf4';
export const color9 = '#93a4ac';
export const colorWhite0 = '#ff7500';
export const colorWhite1 = '#575757';
export const colorWhite2 = '#244696';
export const colorWhite3 = '#fefbf3';
export const colorWhite4 = '#f5c1b8';

export const colorWhite = '#ffffff';
export const colorBlack = '#000000';

export const colorGray = '#454d49';
export const colorBlack900 = '#111512';
export const colorBlack200 = '#696F6B';
export const colorGraySemiLight = '#e5e5e5';
export const colorGrayLight = '#f2f3f2';
export const colorGrayDark = '#2d2d2d';

export const colorPrimary = '#35A47C';
export const colorPrimaryDarken10 = '#298662';
export const colorPrimaryLighten95 = '#F3FAF7';
export const colorPrimary200 = '#76C1A6';
export const colorPrimary50 = '#76c1a';
export const colorGrey50 = '#fbfbfb';
export const colorGrey75 = '#f5f5f5';
export const colorGrey100 = '#e6e6e6';
export const colorGrey200 = '#cacccb';
export const colorGrey400 = '#87928c';

// export const colorPrimaryLighten20 = '#4fb042';
// export const colorPrimaryLighten50 = '#91ce89';
// export const colorPrimaryLighten70 = '#bde1b8';
export const colorPrimaryLighten85 = '#D7EDE5';

export const colorSecondary = '#df3115';
export const colorSecondaryBasic = '#df3014';
export const colorSecondaryDarken10 = '#c72610';
export const colorSecondaryLighten10 = '#e55943';
export const colorSecondaryLighten20 = '#fdf3f1';
export const colorSecondaryLighten85 = '#fae0dc';
export const colorSecondaryLighten95 = '#fdf5f3';

export const colorAccent = '#244696';
export const colorAccent100 = '#5076c0';
export const colorAccentDarken10 = '#203f87';
export const colorAccentLighten20 = '#506bab';
export const colorAccentLighten50 = '#91a3ca';
export const colorAccentLighten70 = '#bdc7df';
export const colorAccentLighten85 = '#dee3ef';
export const colorAccentLighten95 = '#f6f5f8';
export const colorAccent50 = '#fef9e9';

export const colorBlueLight = '#cbdaf4';
export const colorBlueGray = '#cdd7e7';
export const colorBlueDark = '#0A2E83';

export const colorBadge = '#ff7500';
export const colorYellow = '#fac917';
export const colorRed = '#DB0107';
export const colorGreen = '#2f956e';
